<h1 class="album-heading">
  {{album().name}}
  <button type="button" class="heart" [class.saved]="isFavouriteAlbum()" (click)="toggleFavouriteAlbum()"
    [attr.aria-pressed]="isFavouriteAlbum()"
    [attr.aria-label]="isFavouriteAlbum() ? 'Remove album from Favourite Albums' : 'Add album to Favourite Albums'"
    [title]="isFavouriteAlbum() ? 'Remove from Favourite Albums' : 'Add to Favourite Albums'">
    <mat-icon>{{isFavouriteAlbum() ? 'favorite' : 'favorite_border'}}</mat-icon>
  </button>
  <app-deezer-link kind="album" [id]="albumId()" [name]="album().name" />
</h1>
<p>Full track listing for {{album().name}}</p><br />
<p>Click the <mat-icon mat-list-icon>queue_music</mat-icon> icon to add a song to your
  favourites list</p>
<br />
<mat-card>
  <mat-card-content fxLayout="row wrap" fxLayoutGap="16px">
    <div fxFlex.gt-sm="300px">
      <img [src]="album().images[1]?.url" alt="album cover" style="max-width: 100%; border-radius: 4px;" />
    </div>
    <div fxFlex>
      <div class="album-info">
        <p><strong>Record Label: </strong>{{album().label}}</p>
        <p><strong>Release Date: </strong>{{album().release_date}}</p>
        <p><strong>Tracks:</strong> {{album().total_tracks}}</p>
        <p><strong>Popularity: </strong>{{album().popularity}}</p>
        <br />
        <mat-chip-set aria-label="Artist selection">
          @for (ar of album().artists; track ar.id) {
          <mat-chip [routerLink]="['/artist', ar.id]">{{ar.name}}</mat-chip>
          <app-favourite-heart size="small" [saved]="artistFavourites.ids().has(ar.id)" [name]="ar.name" list="Favourite Artists"
            (toggled)="artistFavourites.toggle(ar.id, ar.name)" />
          }
        </mat-chip-set>
        <br />
        @for (cp of album().copyright; track cp) {
        <div><small>{{cp.text}}</small></div>
        }
      </div>
    </div>
  </mat-card-content>
</mat-card>

<br />
@if (player.mode() === 'deezer') {
<div class="album-player">
  @if (player.activeKey() === 'album:' + albumId()) {
  <app-deezer-embed kind="album" [id]="albumId()" />
  } @else {
  <button type="button" class="play-full" (click)="player.toggleActive('album:' + albumId())">&#9654; Play full album</button>
  }
</div>
}
<h2>Track Listing</h2>
<p><app-player-mode-toggle /></p>
<div class="track-list">
  @for (tr of album().tracks; track tr.id; let i = $index) {
    <div class="track-item">
      <span class="track-number">{{tr?.track_number}}</span>
      <span class="track-info">
        <span class="track-name">{{tr?.name}}</span>
        <span class="track-duration">{{(tr?.duration_ms / 60000).toFixed(2)}} min</span>
      </span>
      <div class="track-actions">
        <button mat-icon-button (click)="playTrack(tr)" [disabled]="player.mode() === 'preview' && !tr.preview_url">
          @if (isPlaying(tr.id)) {
            <mat-icon>pause_circle_filled</mat-icon>
          } @else {
            <mat-icon>play_circle_filled</mat-icon>
          }
        </button>
        <button mat-icon-button (click)="addFavourites(i)">
          <mat-icon>queue_music</mat-icon>
        </button>
        <app-deezer-link kind="track" [id]="tr.id" [name]="tr.name" />
      </div>
    </div>
    @if (player.mode() === 'deezer' && player.activeKey() === 'track:' + tr.id) {
    <app-deezer-embed class="track-embed" kind="track" [id]="tr.id" />
    }
  }
</div>

<app-related-artists [artistId]="album().artists[0]?.id" [artistName]="album().artists[0]?.name" />
